<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-trash-alt', fontSet: 'fad'}"
	[headerText]="T.CONFIGURATION_EDITOR_AUDIO_NETWORK_AUDIO_INPUT_TEMPLATE | translate"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<div>
			<mat-form-field color="accent" style="width: 100%">
				<mat-label>
					{{ T.CONFIGURATION_EDITOR_AUDIO_NETWORK_AUDIO_INPUT_TEMPLATE_NUMBER_OF_CHANNELS | translate }}
				</mat-label>
				<input
					[(ngModel)]="amount"
					[class.invalid]="checkInputAmount() !== 'null'"
					[matTooltipDisabled]="checkInputAmount() === 'null'"
					[matTooltip]="checkInputAmount()"
					matInput
					max="100"
					min="1"
					name="inputAmount"
					required
					type="number"
				/>
			</mat-form-field>
		</div>
		<div>
			<mat-form-field color="accent" style="width: 100%">
				<mat-label>
					{{ T.CONFIGURATION_EDITOR_AUDIO_NETWORK_AUDIO_INPUT_TEMPLATE_START_CHANNEL_NUMBER | translate }}
				</mat-label>
				<input
					[(ngModel)]="startChannelNumber"
					[class.invalid]="checkInputChannelNumber() !== 'null'"
					[matTooltipDisabled]="checkInputChannelNumber() === 'null'"
					[matTooltipPosition]="'below'"
					[matTooltip]="checkInputChannelNumber()"
					matInput
					max="1000"
					min="0"
					name="inputStartChannelNumber"
					required
					style="margin-top: 15px"
					type="number"
				/>
			</mat-form-field>
		</div>
		<div>
			<mat-form-field color="accent" style="width: 100%">
				<mat-label [innerHTML]="T.CONFIGURATION_EDITOR_AUDIO_NETWORK_AUDIO_INPUT_TEMPLATE_NAME | translate" />
				<input [(ngModel)]="nameTemplate" matInput name="inputName" required style="margin-top: 10px" type="text" />
				<mat-hint>{{ T.AUDIO_CHANNEL_TEMPLATE_DIALOG_CREATION_HINT | translate }}</mat-hint>
			</mat-form-field>
		</div>

		<div style="margin-top: 30px">
			<mat-form-field color="accent" style="width: 100%">
				<mat-label>
					{{ T.CONFIGURATION_EDITOR_AUDIO_AUDIO_NETWORK_AUDIO_INPUT_TYPE | translate }}
				</mat-label>
				<mat-select [(ngModel)]="selectedAudioChannelType" name="'Audio Channel Type'">
					@for (audioChannelType of audioChannelTypes; track audioChannelType) {
						<mat-option [value]="audioChannelType.value">
							{{ audioChannelType.name }}
						</mat-option>
					}
				</mat-select>
			</mat-form-field>
		</div>

		<div style="margin-top: 30px">
			<mat-form-field color="accent" style="width: 100%">
				<mat-label>
					{{ T.CONFIGURATION_EDITOR_AUDIO_AUDIO_DEVICE_ICON_TYPE | translate }}
				</mat-label>
				<mat-select [(ngModel)]="selectedAudioDeviceIconType" name="'Audio Channel Type'">
					@for (audioDeviceIconType of audioDeviceIconTypes; track audioDeviceIconType) {
						<mat-option [value]="audioDeviceIconType.value">
							{{ audioDeviceIconType.name }}
						</mat-option>
					}
				</mat-select>
			</mat-form-field>
		</div>

		<div style="margin-top: 30px">
			<mat-form-field color="accent" style="width: 100%">
				<mat-label>
					{{ T.CONFIGURATION_EDITOR_AUDIO_AIDIO_NETWORK_PROTOCOL_TYPE | translate }}
				</mat-label>
				<mat-select [(ngModel)]="seletedAudioNetworkProtocolType" name="'Audio Channel Type'">
					@for (audioNetworkProtocolType of audioNetworkProtocolTypes; track audioNetworkProtocolType) {
						<mat-option [value]="audioNetworkProtocolType.value">
							{{ audioNetworkProtocolType.name }}
						</mat-option>
					}
				</mat-select>
			</mat-form-field>
		</div>

		<div style="margin-top: 30px">
			<mat-checkbox [(ngModel)]="compression" class="example-margin">
				{{ T.CONFIGURATION_EDITOR_AUDIO_NETWORK_AUDIO_INPUT_TEMPLATE_COMPRESSION | translate }}
			</mat-checkbox>
		</div>

		<div style="margin-top: 30px">
			<mat-radio-group aria-label="Select an option" class="radioBtn">
				<mat-label>{{ T.CONFIGURATION_EDITOR_AUDIO_NETWORK_AUDIO_INPUT_TEMPLATE_NUMBERING_STYLE | translate }}</mat-label>
				<mat-radio-button [(ngModel)]="numberingStyle" value="every"
					>{{ T.AUDIO_NETWORK_AUDIO_INPUT_TEMPLATE_INPUT_EVERY | translate }}
				</mat-radio-button>
				<mat-radio-button [(ngModel)]="numberingStyle" value="even"
					>{{ T.AUDIO_NETWORK_AUDIO_INPUT_TEMPLATE_INPUT_EVEN | translate }}
				</mat-radio-button>
				<mat-radio-button [(ngModel)]="numberingStyle" value="odd"
					>{{ T.AUDIO_NETWORK_AUDIO_INPUT_TEMPLATE_INPUT_ODD | translate }}
				</mat-radio-button>
			</mat-radio-group>
		</div>
	</ng-container>
	<ng-container actions>
		<sim-button
			(onClick)="ok()"
			[color]="'accent'"
			[disabled]="checkInputChannelNumber() !== 'null' || checkInputAmount() !== 'null'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.CONFIGURATION_EDITOR_AUDIO_OK"
		/>
	</ng-container>
</sim-basic-material-dialog>
